module.exports = __webpack_public_path__ + "example_topic.1c574071b51715dedac07463535a32c9.png";